import React from "react";

const Footer = ({ data }) => {
  const social = Array.isArray(data?.social) ? data.social : [];
  const networks = social.map((network) => (
    <li key={network.name}>
      <a
        href={network.url}
        aria-label={network.name}
        target={network.url?.startsWith("mailto:") ? undefined : "_blank"}
        rel={network.url?.startsWith("mailto:") ? undefined : "noreferrer"}
      >
        <i className={network.className}></i>
      </a>
    </li>
  ));

  return (
    <footer>
      <div className="row">
        <div className="twelve columns">
          <ul className="social-links">{networks}</ul>

          <ul className="copyright">
            <li>&copy; {new Date().getFullYear()} Tuan Nguyen</li>
          </ul>
        </div>
        <div id="go-top">
          <a className="smoothscroll" title="Back to Top" href="#home" aria-label="Back to top">
            <i className="icon-up-open"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
